import FormInput from "../../components/UI/FormInput/input";
import { YellowButton } from "../../components/UI/Button/button";
import { Logo, SOCIALS, WAITLIST_INPUTS } from "../../constants";
import { Link, useNavigate } from "react-router-dom";
import classes from "./waitlist.module.css";
import logo from "../../assets/images/awasource/logo.png";
import { useState } from "react";
import { checkMail } from "../../utils/functions";
import { joinClientWaitlist } from "../../services/clientCalls";
import { errorHandler } from "../../utils";
import { ReactComponent as Loader } from "../../assets/loader/loop2.svg";
import { ReactComponent as StanThumbUp } from "../../assets/svgs/stan-thumb-up.svg";
import Modal from "../../layout/Modal/modal";
const Waitlist = () => {
  const navigate = useNavigate();
  const [aside, setAside] = useState({
    isLoading: false,
    hasSubmitted: false,
    modal: false,
  });

  const [payload, setPayload] = useState({
    full_name: "",
    email: "",
    company: "",
  });

  const handleChange = (e) =>
    setPayload({ ...payload, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAside({ ...payload, hasSubmitted: true });

    if (
      payload.full_name?.length < 3 ||
      payload.company < 2 ||
      !checkMail(payload.email)
    )
      return;
    try {
      setAside({ ...payload, isLoading: true });
      const res = await joinClientWaitlist(payload);

      setAside({ ...payload, isLoading: false, modal: true });
    } catch (error) {
      setAside({ ...payload, isLoading: false });
      errorHandler(error, "");
    }
  };

  return (
    <>
      {aside.modal && (
        <Modal>
          <StanThumbUp />
          <h3 className="t-24 mb-sm mt-sm">Success</h3>
          <p>Thanks for joining the waitlist, you will be notified</p>
          <div className={classes.modal_btn}>
            <YellowButton onClick={() => navigate("/")}>
              Go to home
            </YellowButton>
          </div>
        </Modal>
      )}
      <main className={classes.main}>
        <div className={`mt-md mb-md ${classes.logo}`}>
          <Logo color={"#ffffff"} />
        </div>
        <br />
        <div className={classes.container}>
          <img src={logo} alt="" />
          <p className="mt-sm mb-sm">
            <strong>Signup to be notified about our Product Launch</strong>
          </p>
          <form>
            {WAITLIST_INPUTS.map((item, index) => (
              <FormInput
                extraClasses="mt-sm"
                hasSubmitted={aside.hasSubmitted}
                onChange={handleChange}
                key={`input-${index}`}
                isValid={item.validator(payload[item.name])}
                {...item}
              />
            ))}
            {aside.isLoading ? (
              <div className="mt-sm mb-sm">
                <Loader />
              </div>
            ) : (
              <YellowButton onClick={handleSubmit}>Get Notified</YellowButton>
            )}
          </form>
          <small>Copyright &copy;{new Date().getFullYear()}. All rights reserved by Awasource LLC</small>
        </div>
        <br />
        <div className={classes.links}>
          <Link to={"/team"}>Meet the Team</Link>
          <div className={classes.socials}>
            {SOCIALS.map((data, index) => (
              <a
                href={data.href}
                target="_blank"
                rel="noreferrer"
                key={`social-${index}`}
              >
                <data.image />
              </a>
            ))}
          </div>
        </div>
      </main>
    </>
  );
};

export default Waitlist;
